import { useState } from 'react';
import { PageShell, SlidePanel } from '@/shared/components';
import { RolesTable } from '@/features/teams/components/RolesTable';
import { RolePanel } from '@/features/teams/components/RolePanel';
import type { RoleDefinition } from '@/features/teams/types';

const PANEL_KEY = 'atek_roles_panel_width';

export function HrisRolesPage() {
  const [selectedRole, setSelectedRole] = useState<RoleDefinition | null>(null);
  const [panelOpen, setPanelOpen] = useState(false);

  const openRole = (role: RoleDefinition) => {
    setSelectedRole(role);
    setPanelOpen(true);
  };
  const closePanel = () => setPanelOpen(false);

  return (
    <PageShell>
      <div className="flex min-h-[calc(100vh-240px)]">
        <div className="flex-1 min-w-0 overflow-auto">
          <RolesTable onRowClick={openRole} />
        </div>
        <SlidePanel open={panelOpen} storageKey={PANEL_KEY}>
          {selectedRole && (
            <RolePanel
              key={selectedRole.role}
              role={selectedRole}
              onClose={closePanel}
            />
          )}
        </SlidePanel>
      </div>
    </PageShell>
  );
}
